// btw-front/src/components/charts/MiniBar.jsx
import React from "react";

/**
 * CSS-only 막대 차트.
 *  data: [{ label, value }, ...]
 *  외부 차트 라이브러리 미사용.
 */
export function MiniBar({ data = [], height = 160, valueFormatter, className = "" }) {
  const max = Math.max(1, ...data.map((d) => d.value || 0));
  const fmt = valueFormatter || ((v) => v);
  return (
    <div className={`w-full ${className}`}>
      <div className="flex items-end gap-2" style={{ height }} role="img" aria-label="Bar chart">
        {data.map((d, i) => {
          const pct = max > 0 ? Math.round((d.value / max) * 100) : 0;
          return (
            <div key={i} className="group flex flex-1 flex-col items-center justify-end gap-1">
              <div className="text-[10px] font-medium text-slate-500 tabular-nums opacity-0 transition group-hover:opacity-100">
                {fmt(d.value)}
              </div>
              <div
                className="w-full rounded-t-md bg-accent/80 transition group-hover:bg-accent"
                style={{ height: `${pct}%`, minHeight: d.value > 0 ? 3 : 0 }}
                title={`${d.label}: ${fmt(d.value)}`}
              />
            </div>
          );
        })}
      </div>
      <div className="mt-2 flex gap-2">
        {data.map((d, i) => (
          <div key={i} className="flex-1 text-center text-[10px] text-slate-500">
            {d.label}
          </div>
        ))}
      </div>
    </div>
  );
}
